const getErrorMessage = (error: unknown, fallback: string): string => {
  if (Array.isArray(error) && error.length) return error.join(" ");
  if (typeof error === "string" && error) return error;
  return fallback;
};

export default getErrorMessage;
